import React, { useState } from "react";
import "./ImageFloatingToolbar.css";

const ImageFloatingToolbar = ({
  position,
  onAlign,
  onResize,
  onEdit,
  onDelete,
  onClose,
}) => {
  const [showResizeOptions, setShowResizeOptions] = useState(false);

  if (!position) return null;

  return (
    <>
      {/* Backdrop to close toolbar when clicking outside */}
      <div className="image-toolbar-backdrop" onClick={onClose} />

      <div
        className="image-floating-toolbar"
        style={{
          top: `${position.top}px`,
          left: `${position.left}px`,
        }}
      >
        <button
          className="image-toolbar-btn"
          onClick={() => onAlign("left")}
          title="Align Left"
        >
          ⬅️
        </button>
        <button
          className="image-toolbar-btn"
          onClick={() => onAlign("center")}
          title="Align Center"
        >
          ↔️
        </button>
        <button
          className="image-toolbar-btn"
          onClick={() => onAlign("right")}
          title="Align Right"
        >
          ➡️
        </button>
        <div className="toolbar-divider" />

        {/* Resize dropdown */}
        <div className="resize-dropdown">
          <button
            className="image-toolbar-btn"
            onClick={() => setShowResizeOptions(!showResizeOptions)}
            title="Resize"
          >
            📏
          </button>
          {showResizeOptions && (
            <div className="resize-options">
              <button
                onClick={() => {
                  onResize("25%");
                  setShowResizeOptions(false);
                }}
              >
                25%
              </button>
              <button
                onClick={() => {
                  onResize("50%");
                  setShowResizeOptions(false);
                }}
              >
                50%
              </button>
              <button
                onClick={() => {
                  onResize("75%");
                  setShowResizeOptions(false);
                }}
              >
                75%
              </button>
              <button
                onClick={() => {
                  onResize("100%");
                  setShowResizeOptions(false);
                }}
              >
                100%
              </button>
            </div>
          )}
        </div>

        <div className="toolbar-divider" />
        <button
          className="image-toolbar-btn"
          onClick={onEdit}
          title="Edit Image"
        >
          ✏️
        </button>
        <div className="toolbar-divider" />
        <button
          className="image-toolbar-btn delete-btn"
          onClick={onDelete}
          title="Delete"
        >
          🗑️
        </button>
      </div>
    </>
  );
};

export default ImageFloatingToolbar;
